import { EmojiReactionType } from "modules/emoji/Reactions/types";
import { createSlotsWithReactedUser } from "./createSlotsWithReactedUser";
import { createExpandedSlots } from "./createExpandedSlots";
import { createNarrowedSlots } from "./createNarrowedSlots";
import { populateSlots } from "./populateSlots";
import { AudienceViewAction } from "./actions";
import { Constants } from "./constants";

export type State = {
  isExpanded: boolean;
  isContainerMounted: boolean;
  slots: (string | null)[];
  lastReactionByUserId: {
    [userId: string]: { reactionType: EmojiReactionType; time: number };
  };
};

export const initialState: State = {
  isContainerMounted: false,
  isExpanded: true,
  slots: [],
  lastReactionByUserId: {},
};

const reducer = (state = initialState, action: AudienceViewAction) => {
  switch (action.type) {
    case Constants.SET_IS_CONTAINER_MOUNTED:
      return {
        ...state,
        isContainerMounted: action.isContainerMounted,
      };
    case Constants.TOGGLE_EXPAND:
      return {
        ...state,
        isExpanded: action.isExpanded,
      };
    case Constants.SET_ITEMS_PER_ROW:
      if (state.slots.length === action.itemsPerRow * 2) {
        return state;
      }

      if (action.itemsPerRow * 2 < state.slots.length) {
        return {
          ...state,
          slots: populateSlots(
            createNarrowedSlots(state.slots, action.itemsPerRow),
            action.liveUserIds,
          ),
        };
      }

      return {
        ...state,
        slots: populateSlots(
          createExpandedSlots(state.slots, action.itemsPerRow),
          action.liveUserIds,
        ),
      };
    case Constants.UPDATE_SLOTS:
      return {
        ...state,
        slots: populateSlots(state.slots, action.liveUserIds),
      };
    case Constants.INSERT_REACTED_USER:
      return {
        ...state,
        lastReactionByUserId: {
          ...state.lastReactionByUserId,
          [action.userId]: {
            reactionType: action.reactionType,
            time: Date.now(),
          },
        },
        slots: createSlotsWithReactedUser(
          state.slots,
          {
            ...state.lastReactionByUserId,
            [action.userId]: {
              reactionType: action.reactionType,
              time: Date.now(),
            },
          },
          action.userId,
        ),
      };
    case Constants.DELETE_AUDIENCE_VIEW_REACTIONS:
      return {
        ...state,
        lastReactionByUserId: {},
      };
    case Constants.RESET_AUDIENCE_VIEW_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
